import { Component, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@env/environment';
// Service
import { CommonUtilityService } from '@services/common-utility.service';
import { MsGuestsService } from '@upr-web-primer/ms-guests';
import { LocalStorageService } from '@upr-web-primer/storage';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-delete-account-confirmation',
  templateUrl: './delete-account-confirmation.component.html',
  styleUrls: ['./delete-account-confirmation.component.scss'],
  standalone: false,
})
export class DeleteAccountConfirmationComponent implements OnInit {
  /**
   * Page labels
   * @type any
   */
  pageLabels: any;
  baseUrl: any;
  showContent: boolean;
  deleteAccountConfirmationFlow: boolean;
  /**
   * Constructor
   * @param {ActivatedRoute} route
   * @param {CommonUtilityService} commonUtilityService
   */
  constructor(
    private readonly commonUtilityService: CommonUtilityService,
    @Inject('GlobalDefaults') public globalDefault: any,
    @Inject('Ranges') public ranges: any,
    private readonly cookieService: CookieService,
    private readonly guestsService: MsGuestsService,
    private readonly localStorage: LocalStorageService,
    private readonly title: Title,
  ) {}

  /**
   * ngOnInit - Intial call, pageLabels fetch forom tridion api
   */
  ngOnInit(): void {
    this.pageLabels = this.commonUtilityService?.getResolvedPageData();
    this.showContent =
      environment.config?.dashboard?.showCouponCard === false ? true : false;
    this.deleteAccountConfirmationFlow =
      environment.deleteAccountConfirmationFlow;
    this.title.setTitle(this.pageLabels?.['page.deleteAccountComplete']);
    this.baseUrl = this.commonUtilityService?.prependImageUrl(
      environment?.tridionBaseUrl + this.pageLabels?.['deleteAccComp.image'],
    );
    this.cookieService.deleteAll('/', environment?.cookieSubDomain);
    this.guestsService.helper.localStorage?.clear();
    this.guestsService.helper.sessionStorage?.clear();
    this.localStorage.setItem('isAccountDelete', true);
    this.guestsService.helper.updateLoggedInStatus(false);
  }

  /**
   * goToHomePage - to redirect to login page
   */
  goToHomepage(): void {
    if (this.deleteAccountConfirmationFlow) {
      const url = environment?.basic_version
        ? this.pageLabels?.['dashboard.getTicketsLink']
        : environment?.wtsHostBaseUrl;
      window.open(url, '_self');
    } else {
      this.localStorage.setItem('isAccountDelete', 'true');
      const redirectUrl = this.commonUtilityService.getOidcRedirectionUrl();
      this.commonUtilityService.redirectToOidcApp(redirectUrl);
    }
  }
}
